// extracted by mini-css-extract-plugin
export default {"serviceName":"service_serviceName__ZTpKE"};